import { createContext, useContext } from "react";

export type FunnelAnnouncer = (message: string) => void;

export const FunnelAnnouncerContext = createContext<FunnelAnnouncer>(() => {});

export const useFunnelAnnouncer = (): FunnelAnnouncer => useContext(FunnelAnnouncerContext);
